function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1.818 3.636a1.818 1.818 0 010-3.636h21.47a1.818 1.818 0 010 3.636H1.818zM22.045 18.39a1.813 1.813 0 012.485 2.64c-1.679 1.575-3.577 2.83-5.622 3.683-2 .834-4.14 1.286-6.355 1.286-2.214 0-4.354-.452-6.355-1.286-2.046-.853-3.944-2.108-5.623-3.683a1.814 1.814 0 012.485-2.64c1.361 1.278 2.89 2.292 4.529 2.974 1.554.647 3.225 1 4.964 1 1.739 0 3.41-.353 4.964-1 1.638-.682 3.167-1.696 4.528-2.974zm.475-9.268a1.813 1.813 0 012.408.873 1.813 1.813 0 01-.873 2.408 24.821 24.821 0 01-5.475 1.8c-1.91.397-3.942.613-6.027.613-2.086 0-4.117-.216-6.027-.614a24.88 24.88 0 01-5.475-1.8 1.812 1.812 0 01-.873-2.407 1.813 1.813 0 012.407-.873c1.391.653 2.97 1.175 4.679 1.53 1.643.342 3.424.528 5.289.528 1.865 0 3.645-.186 5.289-.528 1.709-.355 3.289-.879 4.678-1.53z",
  fill: "#fff"
});

function SvgStratticLogoMarkWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    fill: "none"
  }, props), _ref);
}

export default SvgStratticLogoMarkWhite;